/* SmartWash Services page: one card per service with a vehicle-size switch.
   Mini Valet and Full Valet are each two products (standard / SUV, 7 seater, van).
   This shows one card at a time and lets the customer switch size, which swaps
   to the other product's card (price, duration, what's included, booking button). */
(function () {
  var NAMES = ['Mini Valet', 'Full Valet'];
  var SMALL_LABEL = 'Standard';
  var GROUP_LABEL = 'Vehicle size';

  function addStyle() {
    if (document.getElementById('sw-size-style')) return;
    var css = '' +
      '.sw-sub .sw-size{display:flex;gap:4px;margin-top:8px;padding:3px;border-radius:9999px;background:rgba(241,241,241,.08);}' +
      '.sw-sub .sw-size__btn{flex:1 1 auto;min-height:36px;padding:4px 10px;border:0;border-radius:9999px;background:transparent;color:rgba(241,241,241,.7);font-size:12px;line-height:16px;font-weight:500;white-space:nowrap;text-align:center;transition:background-color .3s,color .3s;}' +
      '.sw-sub .sw-size__btn.is-active{background:#D3BE81;color:#0F0F0F;font-weight:600;}' +
      '.sw-sub .sw-size__btn:focus-visible{outline:2px solid #D3BE81;outline-offset:2px;}' +
      /* side by side: the switch takes the same room as the line under the other cards' names, so prices line up */
      '@media screen and (min-width:640px){.sw-sub .sw-size{margin-top:6px;}.sw-sub .sw-size__btn{min-height:30px;}.sw-sub[data-sw-sized] .sw-plan__vehicle{min-height:40px;}}';
    var style = document.createElement('style');
    style.id = 'sw-size-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function text(card, selector) {
    var el = card.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function pair(small, large) {
    var cards = [small, large];
    var labels = [SMALL_LABEL, text(large, '.sw-plan__vehicle') || 'Large'];
    var hints = [text(small, '.sw-plan__vehicle'), text(large, '.sw-plan__vehicle')];
    var touched = false;
    var current = 0;

    /* keep the two cards next to each other so switching never moves the card */
    if (small.nextElementSibling !== large) small.parentNode.insertBefore(large, small.nextSibling);

    /* one shared video: the standard card's video is shown for both sizes */
    var video = small.querySelector('.sw-plan__media video');
    var largeMedia = large.querySelector('.sw-plan__media');
    if (video && largeMedia) {
      var own = largeMedia.querySelector('img, video');
      if (own) own.parentNode.removeChild(own);
    }

    function show(index, focus) {
      current = index;
      cards.forEach(function (card, i) {
        card.hidden = i !== index;
        Array.prototype.forEach.call(card.querySelectorAll('.sw-size__btn'), function (button, b) {
          button.classList.toggle('is-active', b === index);
          button.setAttribute('aria-pressed', b === index ? 'true' : 'false');
        });
      });
      if (video) {
        var media = cards[index].querySelector('.sw-plan__media');
        if (media && video.parentNode !== media) {
          media.insertBefore(video, media.firstChild);
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      }
      if (focus) {
        var target = cards[index].querySelectorAll('.sw-size__btn')[index];
        if (target) target.focus();
      }
    }

    cards.forEach(function (card) {
      var vehicle = card.querySelector('.sw-plan__vehicle');
      var box = document.createElement('div');
      box.className = 'sw-size';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', GROUP_LABEL);
      labels.forEach(function (label, i) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sw-size__btn';
        button.textContent = label;
        if (hints[i]) button.title = hints[i];
        button.addEventListener('click', function () { touched = true; show(i, true); });
        box.appendChild(button);
      });
      if (vehicle) {
        vehicle.hidden = true;
        vehicle.parentNode.insertBefore(box, vehicle);
      } else {
        var name = card.querySelector('.sw-plan__name');
        name.parentNode.insertBefore(box, name.nextSibling);
      }
    });

    show(0, false);

    /* if the larger size is already in the booking when the page opens, show that one */
    if (window.MutationObserver) {
      var watch = new MutationObserver(function () {
        if (touched) return;
        var want = large.classList.contains('is-added') && !small.classList.contains('is-added') ? 1 : 0;
        if (want !== current) show(want, false);
      });
      cards.forEach(function (card) { watch.observe(card, { attributes: true, attributeFilter: ['class'] }); });
    }
  }

  function init() {
    var root = document.querySelector('.sw-cat[data-sw-sub]');
    if (!root || root.dataset.swSized) return;
    var group = root.querySelector('[data-sw-group]');
    if (!group) return;
    root.dataset.swSized = '1';
    addStyle();
    NAMES.forEach(function (name) {
      var set = Array.prototype.filter.call(group.querySelectorAll('article[data-sw-plan]'), function (card) {
        return text(card, '.sw-plan__name') === name;
      });
      if (set.length !== 2) return;
      set.sort(function (a, b) { return Number(a.dataset.price) - Number(b.dataset.price); });
      pair(set[0], set[1]);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
